import {
  bool as boolType,
  arrayOf as arrayType,
  string as stringType,
  shape as shapeType,
  params,
  extend
} from '@thd-nucleus/data-sources';
import { ProductHotspots } from '@thd-olt-component-react/product-hotspots';
import { ShopByRoomPod } from './ShopByRoomPod';
import { SimilarCollections } from '../similar-collections/similar-collections';
import { CurationDataModel } from '../curation/CurationDataModel';

export const ShopByRoomDataModel = extend({
  collection: params({
    collectionId: stringType().isRequired(),
    storeId: stringType(),
    preview: boolType()
  }).shape({
    collectionId: stringType(),
    metadata: shapeType({
      canonicalUrl: stringType(),
      collectionDescription: stringType(),
      name: stringType(),
      productCount: shapeType({
        allProducts: stringType()
      }),
      roomType: stringType(),
      type: stringType(),
      primaryCurationId: stringType(),
      roomStyle: arrayType(shapeType({
        label: stringType(),
        url: stringType()
      })),
      primaryGalleryImage: shapeType({
        images: arrayType({
          url: stringType()
        })
      })
    }),
    products: arrayType(shapeType(extend({
      identifiers: shapeType({
        itemId: stringType()
      }),
      info: shapeType({
        hasVisuallySimilar: boolType()
      })
    }, ShopByRoomPod.dataModel.product))),
    taxonomy: shapeType({
      breadCrumbs: arrayType(shapeType({
        label: stringType(),
        url: stringType()
      }))
    }),
    curations: arrayType(stringType()),
    visuallySimilarItems: arrayType(shapeType({
      itemId: stringType(),
      departmentName: stringType()
    }))
  })
},
ProductHotspots,
CurationDataModel,
SimilarCollections
);
